<template>
    <div>
        <v-sheet
            tile
            height="54"
            class="d-flex mb-4 align-center"
        >
            <v-select
                v-model="type"
                :items="types"
                dense
                outlined
                hide-details
                item-text="label"
                item-value="value"
                class="ma-2"
                label="Ver por"
            ></v-select>
            <v-btn
                icon
                class="ma-2"
                @click="$refs.calendar.prev()"
            >
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="$refs.calendar" class="text-capitalize">
                {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                icon
                class="ma-2"
                @click="$refs.calendar.next()"
            >
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </v-sheet>
        <v-sheet height="600">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-color="getEventColor"
                :type="type"
                :locale="locale"
                @click:event="showEvent"
            >
                <template v-slot:event="{ event }">
                    <div class="px-1">
                        {{ event.start.slice(10,16) }} {{ event.name }}
                    </div>
                </template>
            </v-calendar>
            <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                offset-x
            >
                <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                >
                    <v-toolbar
                        :color="selectedEvent.color"
                        dark
                    >
                        <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!-- <span v-html="selectedEvent.details"></span> -->
                        <!-- details -->
                        <div>
                            <strong>Nombre:</strong> {{ selectedEvent.details?.full_name??'Sin nombre' }}
                            <br>
                            <strong>Celular:</strong> {{ selectedEvent.details?.phone_number??'Sin celular' }}
                            <br>
                            <strong>Fecha y hora:</strong> {{ selectedEvent.details?.day??'Sin fecha' }} {{ selectedEvent.details?.time??'Sin hora' }}
                            <br>
                            <strong>Dato extra:</strong> {{ selectedEvent.details?.extra??'-' }}
                        </div>
                        <br>
                        <v-select
                            :items="['Agendado', 'Pendiente', 'Caído']"
                            label="Estado"
                            outlined
                            dense
                            v-model="selectedEvent.name"
                        >
                            <template v-slot:selection="data">
                                <span :class="{
                                    'green--text': data.item=='Agendado',
                                    'yellow--text text--darken-4': data.item=='Pendiente',
                                    'red--text': data.item=='Caído',
                                }">
                                    {{ data.item }}
                                </span>
                            </template>
                        </v-select>
                        <v-textarea
                            outlined
                            :placeholder="$t('Incluir un comentario para la reserva')"
                            label="Comentario (Opcional)"
                            color="primary"
                            rows="3"
                            v-model="selectedEvent.agent_comment"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="secondary"
                            @click="selectedOpen = false"
                        >
                            Cerrar
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="updateRealState(selectedEvent.name, selectedEvent.id, selectedEvent.agent_comment)"
                            :loading="loading"
                        >
                            Actualizar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </v-sheet>
    </div>
</template>
<script>
  export default {
    data: () => ({
        overlay: false,
        loading: false,
        listOrders: [],
        focus: '',
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        colors: ['green', 'yellow darken-4', 'red'],
        names: ['Agendado', 'Pendiente', 'Caído'],
        events: [],
        type: 'week',
        types: [{label: 'Mes', value: 'month'}, {label: 'Semana', value: 'week'}, {label: 'Día', value: 'day'}],
    }),
    props: ['locale'],
    mounted() {
        this.getListRealStates()
    },
    methods: {
        getEventColor (event) {
            return event.color
        },
        showEvent ({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        /**
         * Add one hour to time string
         */
        addOneHour(timeString) {
            const [hours, minutes] = timeString.split(':').map(Number);
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);
            date.setHours(date.getHours() + 1);
            
            const newHours = date.getHours().toString().padStart(2, '0');
            const newMinutes = date.getMinutes().toString().padStart(2, '0');
            
            return `${newHours}:${newMinutes}`;
        },
        /**
         * Generate color
         */
        generateColor(state) {
            if (state == 'Agendado') {
                return 'green'
            } else if (state == 'Pendiente') {
                return 'yellow darken-4'
            } else if (state == 'Caído') {
                return 'red'
            }
        },
        /**
         * List real states
         */
        async getListRealStates () {
            this.overlay = true
            this.events = []
            await axios.post(`/admin/real_states-full`, {})
            .then(response => {
                // console.log(response)
                if (response.data.length > 0) {
                    response.data.forEach(element => {
                        this.events.push({
                            id: element.id,
                            name: element.state,
                            start: element.day+' '+element.time,
                            end: element.day+' '+this.addOneHour(element.time),
                            color: this.generateColor(element.state),
                            timed: false,
                            details: element,
                            agent_comment: element.agent_comment,
                        })
                    });
                }
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        },
        /**
         * Update real state
         */
        async updateRealState(state, id, agent_comment) {
            this.loading = true
            await axios.post(`/admin/up-real-state/${id}`, {state: state, agent_comment: agent_comment})
            .then(response => {
                // console.log(response)
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Estado actualizado con éxito.'))
                    this.selectedOpen = false
                    this.getListRealStates()
                    this.$emit('update-calendar')
                }
                this.loading = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.loading = false
            })
        },
    },
  }
</script>